import {observable, computed, toJS, action, extendObservable} from 'mobx';
import {Form} from './Form';


export class PasswordRecoveryPasswordForm extends Form {
  constructor() {
    super();
    this.defaultReset();
  }

  fields = observable.map({
    password1: {initValue: ''}, 
    password2: {initValue: ''}, 
  })
}




// WEBPACK FOOTER //
// ./src/view/PasswordRecoveryPasswordForm.js